import React from 'react';
import { Form } from 'antd';

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
  
function checkModified(obj, property, value) {
    console.log('property da controllare:', property);
    console.log('vecchio valore:', obj[property]);
    console.log('nuovo valore:', value);
    if (property === 'day' || property === 'data') {
        console.log('DAY - vecchio valore:', obj[property]);
        console.log('DAY - nuovo valore:', value);
        if (value !== undefined && obj[property] !== undefined && obj[property].toString() === value.toString()) {
        return false;
        }
        return true;
    }
    // if (value !== undefined && obj[property] !== undefined && obj[property].toString() === value.toString().trim()) {
    if (value !== undefined && obj[property] !== undefined) {
        const val = (value === null ? '' : value.toString().trim());
        const oval = (obj[property] === null ? '' : obj[property].toString());
        if (val === oval) {
          return false;
        }
    }
    return true;
    }

class EditableCell extends React.Component {
    state = {
      editing: false,
    }
  
    componentDidMount() {  
      if (this.props.editable && !this.props.disableClickOutsideHandler) {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }
  
    componentWillUnmount() {
      if (this.props.editable) {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }
  
    toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
        if (editing) {
          this.input.focus();
        }
      });
    }
  
    handleClickOutside = (e) => {
      const { editing } = this.state;
      if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
        this.save();
      }
    }
  
    save = (e) => {
      /* if (e) {
        e.preventDefault();
        console.warn(e);
      } */
      // console.warn('something has passed:', JSON.stringify(param));  
      const { record, handleSave, dataIndex } = this.props;
      // console.warn('debug EditableCellTable, record:', JSON.stringify(record));
      
      setTimeout( 
         () => {
            this.form.validateFields((error, values) => {
                if (error) {
                  return;
                }
                // console.warn('debug EditableCellTable, values:', JSON.stringify(values));
                // console.warn(JSON.stringify(this.form.getFieldsValue()));
                this.toggleEdit();
                if (checkModified(record, dataIndex, values[dataIndex])) {
                    handleSave(record, dataIndex, values[dataIndex]);
                }
              });
         },
         0 
      )
      /* this.form.validateFields((error, values) => {
        if (error) {
          return;
        }
        console.warn('debug EditableCellTable, values:', JSON.stringify(values));
        console.warn(JSON.stringify(this.form.getFieldsValue()));
        this.toggleEdit();
        if (checkModified(record, dataIndex, values[dataIndex])) {
            handleSave(record, dataIndex, values[dataIndex]);
        }
      }); */
    }
  
    setRef = (node) => {
        this.input = node;
    }

    render() {
      const { editing } = this.state;
      const {
        editable,
        dataIndex,
        title,
        record,
        index,
        handleSave,
        createComponent,
        disableClickOutsideHandler,
        hasOpts,
        ...restProps
      } = this.props;
      return (
        <td ref={node => (this.cell = node)} {...restProps}>
          {editable ? (
            <EditableContext.Consumer>
              {(form) => {
                this.form = form;
                return (
                  editing ? (
                    createComponent(form,record,dataIndex,this.setRef,this.save, hasOpts)
                  ) : (
                    <div
                      className="editable-cell-value-wrap"
                      style={{ paddingRight: 24 }}
                      onClick={this.toggleEdit}
                    >
                      {restProps.children}
                    </div>
                  )
                );
              }}
            </EditableContext.Consumer>
          ) : restProps.children}
        </td>
      );
      /* return (
        <td ref={node => (this.cell = node)} {...restProps}>
          {editable ? (
            <EditableContext.Consumer>
              {(form) => {
                this.form = form;
                return (
                  editing ? (
                    <FormItem style={{ margin: 0 }}>
                      {form.getFieldDecorator(dataIndex, {
                        rules: [{
                          required: true,
                          message: `${title} is required.`,
                        }],
                        initialValue: record[dataIndex],
                      })(
                        <Textarea rows={2}
                          ref={node => (this.input = node)}
                          onPressEnter={this.save}
                        />
                      )}
                    </FormItem>
                  ) : (
                    <div
                      className="editable-cell-value-wrap"
                      style={{ paddingRight: 24 }}
                      onClick={this.toggleEdit}
                    >
                      {restProps.children}
                      <span className="edit-icon">
                          <Icon type="edit" />
                      </span>
                    </div>
                  )
                );
              }}
            </EditableContext.Consumer>
          ) : restProps.children}
        </td>
      ); */
    }
  }

  export { EditableCell, EditableFormRow };
